"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var Address =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Address, _Record);

  function Address() {
    (0, _classCallCheck2.default)(this, Address);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Address).apply(this, arguments));
  }

  (0, _createClass2.default)(Address, [{
    key: "getFormattedAddress",
    value: function getFormattedAddress() {
      var _this = this;

      var addressLines = ['addressLine1', 'addressLine2'].map(function (line) {
        return _this.get(line) ? _react.default.createElement("span", {
          key: line
        }, _this.get(line), _react.default.createElement("br", null)) : null;
      });
      return _react.default.createElement("div", {
        className: "address-label"
      }, addressLines, _react.default.createElement("span", null, this.get('city'), " ", this.get('state'), " ", this.get('zipCode')), _react.default.createElement("br", null), _react.default.createElement("span", null, this.get('country')), _react.default.createElement("br", null));
    }
  }]);
  return Address;
}((0, _immutable.Record)({
  addressLine1: null,
  addressLine2: null,
  city: null,
  country: null,
  state: null,
  zipCode: null
}));

exports.default = Address;
module.exports = exports.default;